import {makeStyles} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(() => ({
    iconColor: {
        width: 20,
        filter: 'invert(27%) sepia(16%) saturate(4860%) hue-rotate(206deg) brightness(107%) contrast(87%)'
    }
    //https://stackoverflow.com/questions/22252472/how-to-change-the-color-of-an-svg-element
}));

export default function IconImage(props) {
    const classes = useStyles();
    const {url} = props;
    
    return (<img className={classes.iconColor} src={url}/>)
}
